import { isset } from "@cawita/core-front";
import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";


@CwtSchema()
export class ConsentValue extends CwtApiSchema {
    @CwtProp() value: boolean;
    @CwtProp({ ref: Date }) date: Date;

    public get hasGivenConsent() { return this.value === true; }
    public get hasAnsweredConsent() { return isset(this.date); }
}